<template>
  <div
    class="tw-p-[40px] tw-text-[15px] tw-flex tw-flex-col tw-gap-[20px] tw-items-start tw-justify-between tw-py-[40px] tw-text-[#231F20] tw-borer tw-border-[0px] tw-border-t tw-border-solid tw-border-[#EEF0F1]"
  >
    <div
      class="tw-text-[16px] tw-leading-[130%] tw-font-semibold tw-text-[#211F58] tw-mb-[5px]"
    >
      <div class="tw-flex tw-items-center tw-justify-start tw-gap-[10px]">
        {{
          getComponentUiText(
            "app-vendor-create-new-vendor-assessment-modal-title-vendor-details-1",
          )
        }}
        <span>
          <ButtonShowDuplicateAssessment
            :id-popover="'popover-vendor-details'"
            :custom-class="'tw-w-[max-content] md:tw-min-w-[500px] md:tw-max-w-[350px] lg:tw-max-w-[470px]'"
            :class="`!tw-p-0 tw-leading-[16px]`"
            :classes="`!tw-leading-none`"
          >
            <div class="tw-p-[25px]">
              <div
                class="tw-flex tw-flex-col tw-gap-4 tw-text-[11px] tw-font-[400] tw-text-[#231F20]"
              >
                <div
                  class="tw-text-[14px] tw-font-semibold tw-text-[#211f58] tw-font-poppins"
                >
                  {{
                    getComponentUiText(
                      "app-vendor-create-new-vendor-assessment-modal-title-vendor-details-1",
                    )
                  }}
                </div>
                <CustomDescriptionContent
                  :description="
                    getComponentUiText(
                      'app-vendor-create-new-vendor-assessment-modal-popover-description-vendor-details-vendor-1',
                    )
                  "
                  :class="`!tw-p-0 tw-text-[13px] tw-text-[#878787]`"
                >
                </CustomDescriptionContent>
              </div>
            </div>
          </ButtonShowDuplicateAssessment>
        </span>
      </div>
    </div>

    <!-- Company name -->
    <div class="tw-flex tw-items-center tw-justify-between tw-w-full">
      <BaseInput
        id="name"
        v-model="formModel.companyName"
        :validation="$v.companyName"
        :container="'tw-w-full '"
        data-cy-id="vendor-details-company"
        :class-name="'!tw-items-center !tw-mt-[0px]'"
        :is-required="true"
        :label="
          getComponentUiText(
            'app-vendor-create-new-vendor-assessment-modal-label-company-vendor-details-1',
          )
        "
        :placeholder="
          getComponentUiText(
            'app-vendor-create-new-vendor-assessment-modal-placeholder-company-name-vendor-details-1',
          )
        "
        @blur="
          () => {
            $v.companyName.$validate();
          }
        "
      >
      </BaseInput>
    </div>

    <!-- Description -->
    <div class="tw-flex tw-items-center tw-justify-between tw-w-full">
      <BaseInput
        id="name"
        v-model="formModel.description"
        :container="'tw-w-full '"
        :class-name="'!tw-items-center !tw-mt-[0px]'"
        :label="
          getComponentUiText(
            'app-vendor-create-new-vendor-assessment-modal-label-description-vendor-details-1',
          )
        "
        :placeholder="
          getComponentUiText(
            'app-vendor-create-new-vendor-assessment-modal-label-placeholder-description-vendor-details-1',
          )
        "
      >
        <div class="input-container email-container tw-flex">
          <div class="input-container tw-grow tw-flex-1">
            <BFormInput
              v-model="formModel.description"
              type="text"
              :placeholder="
                getComponentUiText(
                  'app-vendor-create-new-vendor-assessment-modal-label-placeholder-description-vendor-details-1',
                )
              "
              data-cy="vendor-details-description"
              :class="[
                'form-control input-base-form-input',
                $v.description.$error ? 'is-invalid' : '',
              ]"
              :state="$v.description.dirty ? $v.description.$error : null"
            />
          </div>
        </div>
      </BaseInput>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { getComponentUiText } from "@/utils/utilities";
import { reactive, watch, defineExpose, onBeforeUnmount } from "vue";
import { BFormInput } from "bootstrap-vue-next";
import { useVuelidate } from "@vuelidate/core";
import BaseInput from "../common/form/baseInput.vue";
import ButtonShowDuplicateAssessment from "../common/setting/buttonShowDuplicateAssessment.vue";
import CustomDescriptionContent from "../common/customDescriptionContent.vue";
import { helpers, required } from "@vuelidate/validators";

const props = defineProps({
  modelValue: {
    type: Object,
    required: true,
  },
});

const formModel = reactive({ ...props.modelValue });

const emit = defineEmits(["update:isDisabled", "update:modelValue"]);

const rules = {
  companyName: {
    required: helpers.withMessage(
      () => getComponentUiText("app-setting-org-detail-required-fields-1"),
      required,
    ),
  },
  description: {},
};

const $v = useVuelidate(rules, formModel as any);

watch(
  () => formModel,
  (value) => {
    emit("update:modelValue", value);
    if (value.companyName) {
      emit("update:isDisabled", true);
    } else {
      emit("update:isDisabled", false);
    }
  },
  { deep: true },
);

onBeforeUnmount(() => {
  formModel.companyName = "";
  formModel.description = "";
});

const isCheckValid = async () => {
  await $v.value.$validate();
  let isValid = !$v.value.$errors || $v.value.$errors.length === 0;

  return { isValid };
};

defineExpose({
  isCheckValid,
});
</script>
